// extracted by mini-css-extract-plugin
module.exports = {"heading":"store-faqs_heading__wBS1r","cantFindWhatYoureLookingFor":"store-faqs_cantFindWhatYoureLookingFor__6L9c3","button":"store-faqs_button__QEXbv"};